import React from 'react';
import { Box } from '@material-ui/core';
import { Button } from '@mui/material';

import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { DeedHeartHands } from 'components/Flow/components/DeedHeartHands';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import { BackButton } from 'components/BackButton/BackButton';

export const NoDesire = ({ send }: StepComponentProps): JSX.Element => (
  <ModalStep
    showProgressBar
    actions={
      <div>
        <BackButton onClick={(): unknown => send?.('PREV')} />
        <Button
          variant="contained"
          onClick={() => {
            window.open(
              'https://www.paypal.com/unifiedonboarding/entry?products=EXPRESS_CHECKOUT',
              '_blank'
            );
          }}
        >
          Create a PayPal Business Account
        </Button>
      </div>
    }
    header={<DeedHeartHands />}
    headerStyles={{
      paddingTop: 16,
    }}
  >
    <Box>
      <ModalTitle>PayPal Business Account Required</ModalTitle>
      <ModalTypography>
        To complete the nonprofit onboarding process, a PayPal Business account is required. This is
        part of our user verification process to ensure secure transactions and compliance. Please
        set up a new PayPal Business account to continue. If you have any concerns or need further
        clarification, our support team is here to help.
      </ModalTypography>
    </Box>
  </ModalStep>
);
